// Uprawnienia zalogowanego konta z GET Access/me (Router pobiera je po uzyskaniu tokenu)
import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { AccessInfo } from "../../api/accessApi";
import { LoadingRegion, Skeleton, SkeletonLines } from "../../components/ui/Skeleton";

export const AccessContext = createContext<AccessInfo | null>(null);
export const useAccess = () => useContext(AccessContext);

// Strony administratora: bez roli admina komunikat zamiast treści (API i tak odrzuca zmiany).
// Dopóki uprawnienia się nie wczytały, nic nie pokazujemy.
export const AdminOnly = ({ children }: { children: ReactNode }) => {
  const access = useAccess();
  if (!access)
    return (
      <LoadingRegion label="Wczytywanie uprawnień" className="p-8 space-y-3">
        <Skeleton className="h-6 w-48" />
        <SkeletonLines lines={3} className="max-w-[480px]" />
      </LoadingRegion>
    );
  if (!access.isAdmin)
    return (
      <div className="p-8">
        <h1 className="text-[20px] font-semibold text-[var(--sc-text)] m-0">Brak uprawnień</h1>
        <p className="text-[13px] text-[var(--sc-muted)] mt-2">
          Bibliotekę pytań i kategorie znalezisk zmieniają administratorzy Scientia Reports.
        </p>
      </div>
    );
  return <>{children}</>;
};
